/**
 * Resets the pagination page number when the current page is greater than 1
 * AND the current page record count equals 1 (presumed to be 0 after delete/
 * remove from class operation).
 */
export default function maybeDecrementPageNumber({
  currentPage,
  currentPageRecords,
  goTo,
}: {
  currentPage: number | undefined
  currentPageRecords: unknown[]
  goTo: (newPageNumber: number) => void
}) {
  if (currentPage !== undefined && currentPage > 1 && currentPageRecords.length === 1) {
    goTo(currentPage - 1)
  }
}
